/**
 * Polaris Web Components Setup
 * Initialize and configure Polaris web components for the application
 */

/**
 * Initialize Polaris Web Components
 * Call this function once when the application starts
 */
export function initializePolarisWebComponents() {
  // Load Polaris web components CSS
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.shopify.com/shopifycloud/app-bridge-host/assets/polaris.css';
  document.head.appendChild(link);

  // Load web components script
  const script = document.createElement('script');
  script.type = 'module';
  script.src = 'https://cdn.shopify.com/shopifycloud/app-bridge-host/assets/polaris-web-components.js';
  document.head.appendChild(script);

  console.log('Polaris Web Components initialized');
}

/**
 * Helper function to create web components with props
 * @param {string} tagName - Web component tag name (e.g., 's-button')
 * @param {Object} props - Properties to set on the element
 * @param {Array|string} children - Child elements or text content
 * @returns {HTMLElement}
 */
export function createElement(tagName, props = {}, children = null) {
  const element = document.createElement(tagName);

  // Set attributes and properties
  Object.keys(props).forEach(key => {
    if (key === 'onClick' || key.startsWith('on')) {
      // Event listeners
      const eventName = key.substring(2).toLowerCase();
      element.addEventListener(eventName, props[key]);
    } else if (typeof props[key] === 'boolean') {
      // Boolean attributes
      if (props[key]) {
        element.setAttribute(key, '');
      }
    } else if (props[key] !== null && props[key] !== undefined) {
      // Regular attributes
      element.setAttribute(key, props[key]);
    }
  });

  // Add children
  if (children) {
    if (Array.isArray(children)) {
      children.forEach(child => {
        if (typeof child === 'string') {
          element.appendChild(document.createTextNode(child));
        } else if (child instanceof HTMLElement) {
          element.appendChild(child);
        }
      });
    } else if (typeof children === 'string') {
      element.textContent = children;
    } else if (children instanceof HTMLElement) {
      element.appendChild(children);
    }
  }

  return element;
}

/**
 * Convert Polaris icon name to SVG or use icon component
 * @param {string} iconName - Icon name
 * @returns {HTMLElement}
 */
export function createIcon(iconName) {
  const icon = document.createElement('s-icon');
  icon.setAttribute('source', iconName);
  return icon;
}

export default {
  initializePolarisWebComponents,
  createElement,
  createIcon
};
